"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitRef = exports.SelectorConfigurationDisplay = exports.StylePanelPage = exports.StylePanelPlane = void 0;
var StylePanelPlane;
(function (StylePanelPlane) {
    StylePanelPlane["Vertical"] = "vertical";
    StylePanelPlane["VerticalCollapse"] = "verticalCollapse";
})(StylePanelPlane = exports.StylePanelPlane || (exports.StylePanelPlane = {}));
var StylePanelPage;
(function (StylePanelPage) {
    StylePanelPage[StylePanelPage["PresetPanel"] = 0] = "PresetPanel";
    StylePanelPage[StylePanelPage["CustomizationPanel"] = 1] = "CustomizationPanel";
})(StylePanelPage = exports.StylePanelPage || (exports.StylePanelPage = {}));
var SelectorConfigurationDisplay;
(function (SelectorConfigurationDisplay) {
    SelectorConfigurationDisplay["Visible"] = "visible";
    SelectorConfigurationDisplay["Hidden"] = "hidden";
    SelectorConfigurationDisplay["ReplaceSelfWithOwnChildren"] = "replaceSelfWithOwnChildren";
})(SelectorConfigurationDisplay = exports.SelectorConfigurationDisplay || (exports.SelectorConfigurationDisplay = {}));
var UnitRef;
(function (UnitRef) {
    UnitRef["CENTIMETERS"] = "centimeters";
    UnitRef["CHARACTER"] = "character";
    UnitRef["CUSTOM"] = "unitless";
    UnitRef["DEGREES"] = "degrees";
    UnitRef["ELEMENTS"] = "elements";
    UnitRef["GRADIANS"] = "gradians";
    UnitRef["INCHES"] = "inches";
    UnitRef["MILLIMETERS"] = "millimeters";
    UnitRef["MILLISECONDS"] = "milliseconds";
    UnitRef["PERCENTS"] = "percents";
    UnitRef["PICAS"] = "picas";
    UnitRef["PIXELS"] = "pixels";
    UnitRef["POINTS"] = "points";
    UnitRef["RADIANS"] = "radians";
    UnitRef["ROOT_ELEMENTS"] = "root-elements";
    UnitRef["SECONDS"] = "seconds";
    UnitRef["TURNS"] = "turns";
    UnitRef["VIEW_HEIGHT"] = "viewport-height";
    UnitRef["VIEW_MAX"] = "viewport-max";
    UnitRef["VIEW_MIN"] = "viewport-min";
    UnitRef["VIEW_WIDTH"] = "viewport-width";
    UnitRef["X_HEIGHT"] = "x-height";
    UnitRef["SPX"] = "spx";
})(UnitRef = exports.UnitRef || (exports.UnitRef = {}));
//# sourceMappingURL=types.js.map